const SIGNUP_INVITE_KEY = "signupInvite";

export const writeSignupInvite = (invite: string): void => {
  localStorage.setItem(SIGNUP_INVITE_KEY, invite);
};

export const readSignupInvite = (): string =>
  localStorage.getItem(SIGNUP_INVITE_KEY) || "";

export const clearSignupInvite = (): void => {
  localStorage.removeItem(SIGNUP_INVITE_KEY);
};
